import * as React from 'react';
import { colors } from '@styleseat/brand';

type ArrowRightCircleIconProps = {
  width?: number;
  height?: number;
  strokeWidth?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ArrowRightCircleIcon = ({
  width,
  height,
  color,
  strokeWidth,
  ...restProps
}: ArrowRightCircleIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g
      stroke="none"
      strokeWidth={strokeWidth}
      fillRule="evenodd"
    >
      <g
        transform="translate(-84.000000, -738.000000)"
        fill={color}
      >
        <g
          transform="translate(94.000000, 748.000000) scale(-1, 1) translate(-94.000000, -748.000000) translate(84.000000, 738.000000)"
        >
          <path
            d="M10,0 C4.4771525,-3.38176876e-16 6.76353751e-16,4.4771525 0,10 C-6.76353751e-16,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C19.9940293,4.47962754 15.5203725,0.00597070634 10,0 Z M10,1.66666667 C14.6023729,1.66666667 18.3333333,5.39762708 18.3333333,10 C18.3333333,14.6023729 14.6023729,18.3333333 10,18.3333333 C5.39762708,18.3333333 1.66666667,14.6023729 1.66666667,10 C1.67171864,5.39972131 5.39972131,1.67171864 10,1.66666667 Z"
            fillRule="nonzero"
          />
          <path
            d="M9.90166667,6.98583333 L8.28583333,8.6025 C8.22609298,8.66208925 8.20819577,8.75182894 8.24050654,8.82977637 C8.2728173,8.9077238 8.34895463,8.9584843 8.43333333,8.95833333 L15,8.95833333 C15.5752966,8.95833333 16.0416667,9.42470339 16.0416667,10 C16.0416667,10.5752966 15.5752966,11.0416667 15,11.0416667 L8.43333333,11.0416667 C8.34931994,11.0418513 8.27363872,11.0924804 8.2414034,11.1700637 C8.20916808,11.247647 8.22668756,11.3370004 8.28583333,11.3966667 L9.90166667,13.0133333 C10.3082863,13.419953 10.3082863,14.0792137 9.90166667,14.4858333 C9.49504702,14.892453 8.83578631,14.892453 8.42916667,14.4858333 L4.67916667,10.7358333 C4.48339766,10.5408352 4.37335073,10.2758979 4.37335073,9.99958333 C4.37335073,9.72326873 4.48339766,9.45833143 4.67916667,9.26333333 L8.42916667,5.51333333 C8.83578631,5.10671369 9.49504702,5.10671369 9.90166667,5.51333333 C10.3082863,5.91995298 10.3082863,6.57921369 9.90166667,6.98583333 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

ArrowRightCircleIcon.defaultProps = {
  width: 24,
  height: 24,
  color: colors.blackInBlack,
  strokeWidth: 1,
};

export default ArrowRightCircleIcon;
